var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStarFill(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.278 21.9989C20.4174 22.8166 19.5581 23.4388 18.8248 23.0511L13.3332 20.1471C13.0408 19.9925 12.6908 19.9925 12.3983 20.1471L6.90662 23.0508C6.17334 23.4385 5.31401 22.8164 5.45343 21.9987L6.50486 15.8321C6.55995 15.509 6.45321 15.1794 6.21915 14.95L1.76044 10.5788C1.16981 9.99973 1.49744 8.99484 2.31586 8.8752L8.46773 7.97591C8.79387 7.92824 9.07558 7.7229 9.2208 7.427L11.968 1.82924C12.3341 1.08333 13.3974 1.08335 13.7635 1.82926L16.5107 7.42743C16.6559 7.72334 16.9377 7.92869 17.2638 7.97636L23.4155 8.87562C24.2339 8.99527 24.5616 10.0002 23.9709 10.5792L19.512 14.9499C19.2779 15.1794 19.1711 15.509 19.2263 15.8322L20.278 21.9989Z",
    fill: "#FEE698",
    stroke: "#4E5865",
    strokeWidth: 1.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarFill);
export default __webpack_public_path__ + "static/media/starFill.9e04a42df23d80f7686a0bc9eee61389.svg";
export { ForwardRef as ReactComponent };